import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    lists: {},
    total_count: '',
    count: 1,
    list: {},
    code: '',
    is_no_records: '',
    updatedtag_id: '',
    updated_id: '',
    image: '',
    igst_tax: [],
    acc_types: [],
    local_tax: [],
    imported_records: {},
    producttaglist: [],
    sales_account: [],
    purchase_account: [],
    unit_list: [],
    gnl_unit_list: [],
    old_unit_ids: "",
    brand_list: [],
    non_sku: [],
    manufacturer_list: [],
    inventory_accounts: [],
    exempt_reason_list: [],
    search_criteria: '',
    delete: {},
    filter_list: {},
    filter_name: '',
    message: {},
    type: {},
    listView: {},
    invoice_list: {},
    quotation_list: {},
    credit_list: {},
    sales_list: {},
    total_invoice_list: '',
    total_quotation_list: '',
    total_credit_list: '',
    total_sales_list: '',
    log_details: '',
    export: {},
    status_code: '',
    status_message: '',
    status_type: '',
    pdt_index_history: '',
    index_status: ''

}

const mutations = {
    PRODUCT_IMPORT_LIST(state, list) {
        state.list = list;
        state.error = "";
    },
    LIST_VIEW_DATA(state, list) {
        state.listView = list
        state.invoice_list = {}
        state.quotation_list = {}
        state.credit_list = {}
        state.sales_list = {}
        state.total_invoice_list = ""
        state.total_quotation_list = ""
        state.total_credit_list = ""
        state.total_sales_list = ""
    },
    SET_DATAS(state, lists) {
        state.lists = lists.product_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
        state.is_no_records = lists.is_no_records
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    UPDATED_TAG(state, updated_id) {
        state.updatedtag_id = updated_id
    },
    LIST_DATA(state, list) {
        state.list = list
    },
    LIST_IMPORTED_RECORDS(state, data) {
        state.imported_records = data
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
    },
    LIST_IMAGE(state, image) {
        state.image = image
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    LIST_DETAILS(state, data) {
        state.igst_tax = data.igst_tax,
            state.local_tax = data.local_tax,
            state.producttaglist = data.producttaglist,
            state.sales_account = data.sales_account,
            state.purchase_account = data.purchase_accounts,
            state.acc_types = data.acc_types,
            state.unit_list = data.unit_list,
            state.gnl_unit_list = data.gnl_unit_list,
            state.inventory_accounts = data.inventory_accounts,
            state.manufacturer_list = data.manufacturer_list,
            state.brand_list = data.brand_list,
            state.exempt_reason_list = data.exempt_reason_list,
            state.old_unit_ids = data.old_unit_ids

    },

    TAG_LIST(state, data) {
        state.producttaglist = data
    },
    DELETE_RESULT(state, delete_result) {
        state.delete = delete_result
    },
    TRANSACTION_LIST(state, data) {
        if (data.type == 'invoice') {
            state.invoice_list = data
        } else if (data.type == 'quotation') {
            state.quotation_list = data
        } else if (data.type == 'credit') {
            state.credit_list = data
        } else if (data.type == 'sales order') {
            state.sales_list = data
        }
    },
    TOTAL_CODE(state, data) {
        if (data.type == 'invoice') {
            state.total_invoice_list = data.pdt_total_count
        } else if (data.type == 'quotation') {
            state.total_quotation_list = data.pdt_total_count
        } else if (data.type == 'credit') {
            state.total_credit_list = data.pdt_total_count
        } else if (data.type == 'salesorder') {
            state.total_sales_list = data.pdt_total_count
        }
    },
    EXEMPT_LIST(state, data) {
        state.exempt_reason_list = data.exempt_details
    },
    STATUS_DETAILS(state, data) {
        state.message = data.data.status;
        state.type = data.data.type;
    },

    MESSAGE_RESULT(state, message) {
        state.message = message
    },
    MANUFACTURER_LIST(state, data) {
        if (data.type == 'manufacturer') {
            state.manufacturer_list = data.list
        }
        if (data.type == 'brand') {
            state.brand_list = data.list
        }

    },
    SKU_LIST(state, lists) {
        state.lists = lists.product_list,
            state.count = lists.show,
            state.total_count = lists.total_count
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },
}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.products.getProducts(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                } else {
                    commit("SET_CODE", response.data);

                }
                return response;
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    adddetails({
        commit,
        rootState
    }, data) {
        return AppService.general.postManufacturer(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('MANUFACTURER_LIST', response.data) // getting all the list in the api call

                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response;
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {


        return AppService.products.getProductsExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.products.postFilterdeleteProduct(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.products.postProduct(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('MESSAGE_RESULT', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit('LIST_ID', response.data.data)
                    commit("SET_CODE", response.data);
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importList({
        commit,
        rootState
    }, list) {

        return AppService.products.postImportProduct(list, rootState.session.token)
            .then(response => {
                commit('LIST_IMPORTED_RECORDS', response.data.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addTag({
        commit,
        rootState
    }, tag_name) {
        return AppService.products.postProductTag(tag_name, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    rootState.amcservice.producttaglist = response.data.data
                    commit('TAG_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.products.postPdtdelete(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                    commit('LIST_LOG', response.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    pdtstatus({
        commit,
        rootState
    }, data) {

        return AppService.products.postPdtstatus(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('LIST_LOG', response.data);
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    singlestatus({
        commit,
        rootState
    }, data) {

        return AppService.products.postsinglestatus(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    pricelistedit({
        commit,
        rootState
    }, data) {
        return AppService.products.pricelistedit(data,
                rootState.session.token)
            .then(response => {
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.products.postProductUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('MESSAGE_RESULT', response.data.data);
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    },{id,type}) {
        
        return AppService.products.getProduct(id,type, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data.data) // getting all the list in the api call
                    commit('LIST_IMAGE', response.data.image) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchProductDetails({
        commit,
        rootState
    }) {
        return AppService.products.getProductDetails(rootState.session.token)
            .then(response => {
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchProductFilterDetails({
        commit,
        rootState
    }) {
        return AppService.products.getProductFilterDetails(rootState.session.token)
            .then(response => {
                rootState.general.filterdetails = response.data
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.products.postFiltercreateProduct(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.products.postFilterudpateProduct(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchViewList({
        commit,
        rootState
    }, id) {

        return AppService.products.getProductView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_VIEW_DATA', response.data.data)

                    commit("SET_CODE", response.data);
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    // product transaction view
    fetchproductinvoiceview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });

        return AppService.products.postProductinvoiceview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    if(response.data.module == 'Product'){
                        commit("SET_CODE", response.data);
                    }
                    else if(response.data.module == 'bundle'){
                        rootState.amcservice.status_code = response.data.code;
                        rootState.amcservice.status_message = response.data.status;
                        rootState.amcservice.status_type = response.data.status;
                    }
                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchproductcreditview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.products.postProductcreditview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    if(response.data.module == 'Product'){
                        commit("SET_CODE", response.data);
                    }
                    else if(response.data.module == 'bundle'){
                        rootState.amcservice.status_code = response.data.code;
                        rootState.amcservice.status_message = response.data.status;
                        rootState.amcservice.status_type = response.data.status;
                    }
                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchproductquotationview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });

        return AppService.products.postProductquotationview(page, show, data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    if(response.data.module == 'Product'){
                        commit("SET_CODE", response.data);
                    }
                    else if(response.data.module == 'bundle'){
                        rootState.amcservice.status_code = response.data.code;
                        rootState.amcservice.status_message = response.data.status;
                        rootState.amcservice.status_type = response.data.status;
                    }
                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchsalesorderview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });

        return AppService.products.postsalesorderview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    if(response.data.module == 'Product'){
                        commit("SET_CODE", response.data);
                    }
                    else if(response.data.module == 'bundle'){
                        rootState.amcservice.status_code = response.data.code;
                        rootState.amcservice.status_message = response.data.status;
                        rootState.amcservice.status_type = response.data.status;
                    }
                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    //  total transaction each count of product  
    viewtotalcount({
        commit,
        rootState
    }, data) {

        return AppService.products.getViewTotalCount(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    if(response.data.module == 'Product'){
                        commit("SET_CODE", response.data);
                    }
                    else if(response.data.module == 'bundle'){
                        rootState.amcservice.status_code = response.data.code;
                        rootState.amcservice.status_message = response.data.status;
                        rootState.amcservice.status_type = response.data.status;
                    }
                    commit('TOTAL_CODE', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    //  delete customer 
    deleteproduct({
        commit,
        rootState
    }, data) {

        return AppService.products.getProductDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    manufacturerdelete({
        commit,
        rootState
    }, id, type) {
        return AppService.general.manufacturerdelete(id, type, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('MANUFACTURER_LIST', response.data) // getting all the list in the api call
                    commit('DELETE_DROPDOWN', response) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    // commit('ERROR_STATUS', 500) // getting all the list in the api call
                }
            })
    },
    addexempt({
        commit,
        rootState
    }, data) {
        return AppService.general.postexempt(data, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status) // getting all the list in the api call
                commit('UPDATED_TAG', response.data.updated_id)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    return response.data
                } else {
                    rootState.products.exempt_reason_list = response.data.data
                    rootState.sales.exempt_reason_list = response.data.data
                    rootState.amcservice.exempt_reason_list = response.data.data
                    rootState.productgroup.details.exempt_reason_list = response.data.data
                    rootState.credit.exempt_reason_list = response.data.data

                    commit('MESSAGE_RESULT', response.data.data) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    // commit('ERROR_STATUS', 500) // getting all the list in the api call
                }
            })
    },
    importproductvalidation({
        commit,
        rootState
    }, data) {

        return AppService.products.importproductvalidation(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('PRODUCT_IMPORT_LIST', response.data); // getting all the list in the api call
                    return response.data
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importProduct({
        commit,
        rootState
    }, data) {

        return AppService.products.importProduct(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_RESULT', response.data.status); // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createsku({
        commit,
        rootState
    }, data) {
        return AppService.products.postcreatesku(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit("STATUS_DETAILS", response); // getting all the list in the api call 
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    productswithoutsku({
        commit,
        rootState
    }, {
        page,
        show
    }) {
        return AppService.products.getproductswithoutsku(page,
                show, rootState.session.token)
                .then(response => {
                    if (response.status == 203) {
                        window.location.href = process.env.VUE_APP_LOGOUT_URL;
                    } else if (response.data.code != 404) {
                        commit("SET_CODE", response.data);
    
                    commit('SKU_LIST', response.data.data) // getting all the list in the api call
                } else {
                    commit("SET_CODE", response.data);
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportsku({
        commit,
        rootState
    }, {
        page,
        show
    }) {
        return AppService.products.getproductsskuexport(page,
                show, rootState.session.token)
                .then(response => {
                    if (response.status == 203) {
                        window.location.href = process.env.VUE_APP_LOGOUT_URL;
                    } else {
                        commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                    }
                })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    customizeunits({
        commit,
        rootState
    }, data) {
        return AppService.products.customizePdtUnits(data, rootState.session.token)
            .then(response => {

                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

}
export default {
    namespaced,
    state,
    mutations,
    actions
}